import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800 z-50">
      <h1 className="text-3xl font-bold mb-6">Terms &amp; Conditions</h1>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">1. Definitions</h2>
        <ul className="list-disc list-inside space-y-1">
          <li><strong>"User"</strong>: Any individual or entity accessing or using the Mineralex Group website.</li>
          <li><strong>"Website"</strong>: <a href="https://www.mineralexgroup.com" className="text-blue-600 underline">www.mineralexgroup.com</a>, owned and operated by Mineralex Group.</li>
          <li><strong>"Company" / "Mineralex Group"</strong>: Mineralex Group, future entity with jurisdiction determined according to legal advisers.</li>
          <li><strong>"Services"</strong>: All services offered through the Mineralex Group website, including token offerings and related functionalities.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">2. Acceptance of Terms</h2>
        <p>By accessing or using our website and services, you confirm that you have read, understood, and agreed to these Terms &amp; Conditions.</p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">3. User Obligations and Prohibited Uses</h2>
        <ul className="list-disc list-inside space-y-1">
          <li>Provide accurate, current, and complete information.</li>
          <li>Not use the website or services for unlawful, fraudulent, or harmful activities.</li>
          <li>Refrain from any activities that could damage, disable, or impair the website.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">4. Intellectual Property Rights</h2>
        <p>
          All website content, including text, graphics, logos, and software, is owned by Mineralex Group or licensed accordingly. 
          Users may not copy, modify, distribute, or use any content without explicit written permission.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">5. Liability Limitations and Disclaimers</h2>
        <p>
          Mineralex Group is not responsible for indirect, incidental, consequential damages, or losses related to the use of the website or services. 
          The website and services are provided &quot;as is,&quot; without any warranties.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">6. Governing Law</h2>
        <p>
          The governing law and jurisdiction for these Terms &amp; Conditions will be determined according to the advice provided by Mineralex Group's legal advisers 
          and will be updated accordingly.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">7. Dispute Resolution</h2>
        <p>
          Any disputes arising will initially seek resolution through negotiation. If unresolved, disputes shall be settled by the competent courts 
          in the jurisdiction advised by Mineralex Group's legal advisers.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-xl font-semibold mb-2">8. Updates to Terms & Conditions</h2>
        <p>
          Mineralex Group reserves the right to modify these terms at any time. Users will be notified via website notifications or email. 
          Continued use of services constitutes acceptance of changes.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
